import { Grid, Paper } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import {
	STYLE_MASTER_SATU_BUNDLE,
	postBundleDetail,
	postBundleProses,
} from "./helpers";
import { InputReactDatepicker, Loading, MasterButton } from "App/Component/ui";
import BundleDetailHeaderTable from "./BundleDetailHeaderTable";
import { BundleCtx } from "../context/context";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";

function BundleDetailHeader({
	formDataBundle,
	setFormDataBundle,
	resetPagination,
	setNewData,
	pagination,
	onPrevious,
	onNext,
	handleClickPageNumber,
	handleChangeLimit,
	loading,
	formFilter,
	setFormFilter,
}) {
	const { state } = useContext(BundleCtx);
	const rows = state.detail.data;
	const totalData = state.detail.count;

	const classes = STYLE_MASTER_SATU_BUNDLE();

	const [loadingDetail, setLoadingDetail] = useState(false);

	useEffect(() => {
		setNewData(1, 10, {
			id_bundle: formDataBundle.id_bundle,
			tglAwal: formFilter.tglAwal,
			tglAkhir: formFilter.tglAkhir,
		});
	}, []);

	const handleSelectDetail = () => {
		setNewData(1, 10, {
			id_bundle: formDataBundle.id_bundle,
			tglAwal: formFilter.tglAwal,
			tglAkhir: formFilter.tglAkhir,
		});
	};

	const handleSelect = async (rows) => {
		setLoadingDetail(true);

		const response = await postBundleProses(formDataBundle.id_bundle);

		if (response.state) {
			setLoadingDetail(false);
			defaultToastSuccess(response.message);
			setNewData(1, 10, {
				id_bundle: formDataBundle.id_bundle,
				tglAwal: formFilter.tglAwal,
				tglAkhir: formFilter.tglAkhir,
			});
		} else {
			setLoadingDetail(false);
			defaultToastError(response.message);
		}
	};

	return (
		<>
			<Loading show={loadingDetail} />

			<div>
				<Paper className={classes.paper}>
					<h4>Detail Header</h4>

					<div className="mb-1">
						<Grid container direction="row" spacing={1}>
							<Grid item md={6}>
								<InputReactDatepicker
									selected={formFilter.tglAwal}
									label="TANGGAL MULAI"
									handleChangeToday={(e) =>
										setFormFilter({
											...formFilter,
											tglAwal: e,
										})
									}
									onChange={(e) =>
										setFormFilter({
											...formFilter,
											tglAwal: e,
										})
									}
								/>
							</Grid>
							<Grid item md={6}>
								<InputReactDatepicker
									selected={formFilter.tglAkhir}
									label="TANGGAL SELESAI"
									handleChangeToday={(e) =>
										setFormFilter({
											...formFilter,
											tglAkhir: e,
										})
									}
									onChange={(e) =>
										setFormFilter({
											...formFilter,
											tglAkhir: e,
										})
									}
								/>
							</Grid>
						</Grid>
						<Grid
							container
							spacing={1}
							alignItems="flex-end"
							justifyContent="flex-end"
						>
							<div
								style={{
									display: "flex",
									alignItems: "flex-end",
									justifyContent: "flex-end",
									marginTop: "14px",
								}}
							>
								<MasterButton
									type="submit"
									size="md"
									color={"lightgreen"}
									name={"Cari"}
									onClick={() => handleSelectDetail()}
								/>
							</div>
						</Grid>
					</div>

					<BundleDetailHeaderTable
						rows={rows}
						handleSelect={handleSelect}
						totalData={totalData}
						resetPagination={resetPagination}
						setNewData={setNewData}
						pagination={pagination}
						onPrevious={onPrevious}
						onNext={onNext}
						handleClickPageNumber={handleClickPageNumber}
						handleChangeLimit={handleChangeLimit}
						loading={loading}
						formFilter={formFilter}
						setFormFilter={setFormFilter}
					/>
				</Paper>
			</div>
		</>
	);
}

export default BundleDetailHeader;
